import React , {Component} from 'react';
import {
    Page  , Link , Actions , ActionsGroup , ActionsLabel , ActionsButton , Popup , Navbar , NavRight
} from 'framework7-react';

import { connect } from "react-redux";
import {
    toolbar
} from "../actions";
import * as axios from "axios/index";
import OrderDetailsLoader from "../Loader/OrderDetailsLoader";
import * as vars from './Vars';

class OrderDetails extends Component{


    onPageBeforeIn(){
        this.props.toolbar(false)
    }

    constructor(props){
        super(props)
        this.state = {
            requestLoading : true ,


            order : {
                address : '' ,
                id : 0 ,
                branchs_ID: "" ,
                branchs_title_fa: "",
                comment: "",
                date: "",
                error: 0,
                error_body: "",
                foods: [] ,
                pay_type: -1,
                pay_type_text: "",
                price_delivery: "",
                price_discount: "",
                price_gift: "",
                price_payable: "",
                price_real: "",
                price_tax: "",
                step: 0,
                step_text: "",
                time: "",
                time_u: "",
            } ,


        }
    }
    componentWillMount(){

        if (localStorage.getItem('logged') === undefined  || localStorage.getItem('logged') === null)
        {
            this.$f7router.navigate('/login-singup/')
            return
        }


        let data = new FormData()
        data.append('imei_code' , localStorage.getItem('imeiCode') )
        data.append('users_ID' , localStorage.getItem('users_ID') )
        data.append('orders_ID' ,this.props.f7route.params.orderId  )


        axios.post(vars.PreUrl + 'https://www.lavefood.com/v1/orders/details' , data )
            .then(response => {

                let data = response.data.result[0]
                console.log(data)
                if (data.error === 0)
                {
                    this.setState({
                        order : {
                            ...data ,
                            id : this.props.f7route.params.orderId
                        } ,
                        requestLoading : false ,
                    })

                }
                else{
                    this.$f7router.navigate('/orders-list/')
                }



            })
            .catch(error => {
                console.log(error)
            })

    }


    render(){

        const  object  = this.state.order
        return(
            <Page name="ordersDetails" className="bg-white" onPageBeforeIn={this.onPageBeforeIn.bind(this)}>

                <div id="inner-header" >

                    <Link back id="back">
                        <img src="https://www.lavefood.com/webappassets/images/back.svg" />
                    </Link>
                    <div className="title">
                        جزئیات سفارشات
                    </div>
                </div>
                <div id="inner-header-separator" />

                {
                    this.state.requestLoading === true ?
                        (<OrderDetailsLoader  />) : (
                            <div id="orders-details">

                                <div id="header">
                                    <div className="b-row no-gutters">
                                        <div className="b-col-6 pl-1 text-left">
                                            <div className="order-step-title">
                                                :وضعیت سفارش
                                            </div>
                                        </div>
                                        <div className="b-col-6 pr-1">
                                            <div className={ "order-step step" +  object.step  }>
                                                {object.step_text}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="order-details-content">
                                    <div className="b-row no-gutters align-items-center">
                                        <div className="b-col-5">
                                            <div className="b-row no-gutters">
                                                <div className="b-col-6">
                                                    <div className="title">
                                                        کد سفارش
                                                    </div>
                                                </div>
                                                <div className="b-col-6">
                                                    <div className="content">
                                                        {object.id}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="b-row no-gutters mt-2">
                                                <div className="b-col-6">
                                                    <div className="title">
                                                        رستوران
                                                    </div>
                                                </div>
                                                <div className="b-col-6">
                                                    <div className="content">
                                                        {object.branchs_title_fa}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="b-col-3" id="center-details">

                                            <div className="b-row no-gutters">
                                                <div className="b-col-12">
                                                    <div className="content text-center">
                                                        {object.date}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="b-row no-gutters mt-2">
                                                {/*<div className="b-col-6">
                                                    <div className="title">
                                                        ساعت
                                                    </div>
                                                </div>*/}
                                                <div className="b-col-12">
                                                    <div className="content">
                                                        {object.time}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="b-col-4">

                                            <div className="b-row no-gutters">
                                                <div className="b-col-12">
                                                    <div className="content content-2  text-center">
                                                        مشکلی وجود دارد؟
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="b-row no-gutters text-center mt-2">
                                                <div className="b-col-12">
                                                    <div className="title">
                                                        <Link id="call-link">
                                                            <img src="https://www.lavefood.com/webappassets/images/call.svg" />
                                                            <span>تماس</span>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div id="foods-container">


                                    {object.foods.map((value , index) => (
                                        <div className="orders-details-food" key={index} >
                                            <div className="b-row no-gutters justify-content-between align-items-center" >
                                                <div className="b-col-auto">
                                                    <div className="title">
                                                        {value.title_fa}
                                                    </div>
                                                </div>
                                                <div className="b-col-auto">
                                                    <div className="price">
                                                        {value.food_price}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    ))}





                                </div>

                                <div id="address">

                                    <img className="icon" src="https://www.lavefood.com/webappassets/images/back.svg" />

                                    {object.address}
                                </div>

                                <div id="prices">

                                    <div className="b-row item">
                                        <div className="b-col-6">
                                            <div className="total">
                                                جمع کل و مالیات
                                            </div>
                                        </div>
                                        <div className="b-col-6">
                                            <div className="total text-left">
                                                {object.price_real}
                                            </div>
                                        </div>
                                    </div>


                                    <div className="b-row item">
                                        <div className="b-col-6">
                                            <div className="discount">
                                                تخفیف ویژه
                                            </div>
                                        </div>
                                        <div className="b-col-6">
                                            <div className="discount text-left">
                                                {object.price_discount}
                                            </div>
                                        </div>
                                    </div>


                                    <div className="b-row item">
                                        <div className="b-col-6">
                                            <div className="delivery">
                                                هزینه پیک
                                            </div>
                                        </div>
                                        <div className="b-col-6">
                                            <div className="delivery text-left">
                                                {object.price_delivery}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="b-row item">
                                        <div className="b-col-6">
                                            <div className="payable">
                                                مبلغ قابل پرداخت
                                            </div>
                                        </div>
                                        <div className="b-col-6">
                                            <div className="payable text-left">
                                                {object.price_payable}
                                            </div>
                                        </div>
                                    </div>


                                </div>

                            </div>



                        )
                }





                {
                    this.state.requestLoading === false ?
                        (

                            <div id="order-details-footer">
                                <Link href={`/tracking/${object.id}/`} className="tracking-link">
                                    رهگیری سفارش
                                </Link>
                            </div>

                        ) :
                            (``)
                }




            </Page>
        )
    }
}

const mapDispatchToProps = dispatch => ({


    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        products : state.products ,
        cart : state.cart ,
        branch : state.branch ,
        toolbarShow : state.toolbar
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(OrderDetails);